import store from '../store';
import ContactModel from "../models/ContactModel";
import convert from 'xml-js'

export default class Contact {
  constructor(api) {
    this.api = api
  }

  loadNew(id) {
    if (id==0) {
      const items = []
      items.push(new ContactModel())
      console.log('load(0): ', items.length)
      store.commit('setContactItems', items)
      return
    }
  }

  loadSelected(ids) {
    this.api.call_busy({
      '_class': 'Contact',
      '_method': 'load',
      'id': ids,
    }).then(response => {
      const items = []
      if (response.aitem) {
        if (!response.aitem.length) {
          response.aitem = [response.aitem]
        }
        for (let i in response.aitem) {
          items.push(new ContactModel().mapAitem(response.aitem[i]))
        }
      }
      store.commit('setSelectedContacts', items)
    })
  }


  load(id) {
    if (id == 'new') {
      return new Promise ((resolve) =>{
        const items = []
        let activeContact = new ContactModel()
        items.push(activeContact)
        console.log('load(new): ', items.length)
        store.commit('setContactItems', items)
        // this.setActiveContact(activeContact)
        store.commit('setActiveContact', activeContact)
        resolve()
      })
    } else {
      return this.api.call_busy({
        '_class': 'Contact',
        '_method': 'load',
        'id': id,
      }).then(response => {
        // const activeContact = this.setActiveContact(response)
        // const activeContact = store.getters.activeContact
        const activeContact = new ContactModel().mapAitem(response.aitem)
        const companyItems = store.getters.companyItems
        if (activeContact['company']) {
          companyItems.unshift(activeContact['company'])
        }
        // const contactItems = store.getters.contactItems
        // const idx = contactItems.findIndex(a => a.id === activeContact.id)
        // if (idx > -1) {
        //   contactItems[idx] = activeContact
        // } else {
        //   contactItems.push(activeContact)
        // }
        store.commit('setActiveContact', activeContact)
        store.commit('setCompanyItems', companyItems)
        // store.commit('setContactItems', contactItems)
      })
    }
  }

  setActiveContact(response) {
console.log('setActiveContact', response)
    const activeContact = store.getters.activeContact
    // const companyItems = store.getters.companyItems
    // activeContact.mapAitem(response.aitem)
    // if (activeContact['company']) {
    //   companyItems.unshift(activeContact['company'])
    // }
    // store.commit('setActiveContact', activeContact)
    // store.commit('setCompanyItems', companyItems)
    return activeContact
  }

  create() {
    let xml = this._parseActiveContactToXml()
// console.log(xml);return
    return this.api.call_busy({
      '_class': 'Contact',
      '_method': 'create',
      'xml': xml,
    }).then(response => {
      const activeContact = store.getters.activeContact
      activeContact.id = response.aitem._attributes.id
      activeContact.creator = response.aitem.fields.creator._attributes.name
      activeContact.created = response.aitem.fields.created._text
      activeContact.modifier = response.aitem.fields.modifier._attributes.name
      activeContact.modification_date = response.aitem.fields.modification_date._text
      store.commit('setActiveContact', activeContact)
    })
  }

  update() {
    let xml = this._parseActiveContactToXml()
// console.log(xml);return
    return this.api.call_busy({
      '_class': 'Contact',
      '_method': 'update',
      'xml': xml,
    })
  }

  merge(targetContact, sourceContacts, mergeResult) {
    let xml = this._parseMergeContactToXml(targetContact, sourceContacts, mergeResult)
console.log(xml)
    return this.api.call_busy({
      '_class': 'Contact',
      '_method': 'merge',
      'xml': xml,
    })
  }

  delete(id, delete_account) {
    return this.api.call_busy({
      '_class': 'Contact',
      '_method': 'delete',
      'id': id,
      'delete_account': +delete_account,
    }).then(() => {
      store.commit('setActiveContact', new ContactModel())
    })
  }

  // Notes/Notices

  create_notice({aitem_id, text}) {
    return this.api.call_busy({
      '_class': 'Contact',
      '_method': 'create_notice',
      'aitem_id': aitem_id,
      'text': text,
    })
  }

  update_notice({notice_id, aitem_id, text}) {
    return this.api.call_busy({
      '_class': 'Contact',
      '_method': 'update_notice',
      'notice_id': notice_id,
      'aitem_id': aitem_id,
      'text': text,
    })
  }

  delete_notice({notice_id, aitem_id}) {
    return this.api.call_busy({
      '_class': 'Contact',
      '_method': 'delete_notice',
      'notice_id': notice_id,
      'aitem_id': aitem_id,
    })
  }

  // --- helpers


  _parseMergeContactToXml(targetContact, sourceContacts, mergeResult) {

    console.log('targetContact:', targetContact)
    console.log('sourceContacts:', sourceContacts)
    console.log('mergeResult:', mergeResult)

    let jsonObject = {
      request: {
        merge: {
          source: {
            aitem: []
          },
          target: {
            aitem: {
              _attributes: {
                id: targetContact.id
              },
              fields: {
              },
              categories: {
                cat: [
                ]
              },
              freefields: {
                ff: [
                ]
              },
              pictures: {
                picture: [
                  {
                    _attributes: {
                      purpose: 'reg_photo',
                      encoding: 'Base64',
                      mimetype: 'image/jpeg',
                    },
                    _text: '', // base64 encoded image
                    // remove - Möchten Sie das Kontaktfoto wirklich endgültig löschen?
                    // 
                  }
                ]
              }
            }
          }
        }
      }
    }
    jsonObject.request.merge.source.aitem = sourceContacts.map((contact) =>{
      return {
        _attributes: {
          id: contact.id
        }
      }
    })

    let merged
    // ----------- common fields --------------

    merged = Object.entries(mergeResult).filter((m) => {
      return m[0].indexOf('cat_') != 0 && m[0].indexOf('free_') != 0
    })

    merged.forEach(m => {
      jsonObject.request.merge.target.aitem.fields[m[0]] = m[1]
    })

    // ----------- categories --------------

    merged = Object.entries(mergeResult).filter((m) => {
      return m[0].indexOf('cat_') == 0
    })

    jsonObject.request.merge.target.aitem.categories.cat = merged.map(m => m[1]).flat().map(cid => {
      return {_attributes: {id: cid}}
    })
 
    // ----------- freefields --------------

    merged = Object.entries(mergeResult).filter((m) => {
      return m[0].indexOf('free_') == 0
    })

    jsonObject.request.merge.target.aitem.freefields.ff = merged.map(m => {
      return {_attributes: {id: m[0].substr(5)},  _text: m[1]}
    })

    // ----------- pictures --------------

    // if (targetContact.pictures && targetContact.pictures.length) {
    //   targetContact.pictures.forEach(picture => {
    //     jsonObject.request.merge.target.aitem.pictures.picture.push({
    //       _attributes: {
    //         purpose: picture.purpose,
    //         encoding: 'Base64',
    //         mimetype: picture.mimetype,
    //       },
    //       _text: picture.content,
    //     })
    //   })
    // }
    return convert.json2xml(jsonObject, {compact: true})
  }


  _parseActiveContactToXml() {
    const activeContact = store.getters.activeContact
    let jsonObject = {
      request: {
        aitem: {
          _attributes: {
            id: activeContact.id ? activeContact.id : 0
          },
          fields: {
          },
          categories: {
            cat: [
            ]
          },
          freefields: {
            ff: [
            ]
          },
          pictures: {
            picture: [
              // {
              //   _attributes: {
              //     purpose: 'reg_photo',
              //     encoding: 'Base64',
              //     mimetype: 'image/jpeg',
              //   },
              //   _text: '', // base64 encoded image
              //   // remove - Möchten Sie das Kontaktfoto wirklich endgültig löschen?
              //   // 
              // }
            ]
          }
        }
      }
    }
    const fields = require('../config/fields.json')
    fields.forEach(field => {
      if (field.settable && typeof activeContact[field.field] !== 'undefined') {
        jsonObject.request.aitem.fields[field.id] = typeof activeContact[field.field] === 'boolean' ? +activeContact[field.field] : activeContact[field.field]
      }
    })

    // categories
    if (activeContact.categories && Object.keys(activeContact.categories).length) {
      Object.keys(activeContact.categories).forEach(key => {
        let category = activeContact.categories[key]
        if (!Array.isArray(category)) {
          category = [category]
        }
        for (let cat of category) {
          jsonObject.request.aitem.categories.cat.push({
            _attributes: {
              id: cat
            }
          })
        }
      })
    }

    // custom fields
    if (activeContact.customFields && Object.keys(activeContact.customFields).length) {
      Object.keys(activeContact.customFields).forEach(key => {
        if (typeof activeContact.customFields[key] !== 'undefined') {
          jsonObject.request.aitem.freefields.ff.push({
            _attributes: {
              id: key
            },
            _text: activeContact.customFields[key]
          })
        }
      })
    }

    if (activeContact.pictures && activeContact.pictures.length) {
      activeContact.pictures.forEach(picture => {
        jsonObject.request.aitem.pictures.picture.push({
          _attributes: {
            purpose: picture.purpose,
            encoding: 'Base64',
            mimetype: picture.mimetype,
          },
          _text: picture.content,
        })
      })
    }
    return convert.json2xml(jsonObject, {compact: true})
  }

}